/**
 * SKU product fields for mapping (onlineStore i18n). Override via fieldsConfig for other features.
 */
import type { SkuProductFieldOption } from './product-field-mapping.types';

const I18N_PREFIX = 'onlineStore.form.product_field_mapping.sku_fields';

export const DEFAULT_SKU_PRODUCT_FIELDS: SkuProductFieldOption[] = [
  { code: 'skuCode', labelKey: `${I18N_PREFIX}.sku_code`, required: true },
  { code: 'skuName', labelKey: `${I18N_PREFIX}.sku_name`, required: true },
  { code: 'name', labelKey: `${I18N_PREFIX}.name` },
  { code: 'categoryId', labelKey: `${I18N_PREFIX}.category_id` },
  { code: 'categoryCode', labelKey: `${I18N_PREFIX}.category_code` },
  { code: 'categoryName', labelKey: `${I18N_PREFIX}.category_name` },
  { code: 'brandId', labelKey: `${I18N_PREFIX}.brand_id` },
  { code: 'brandCode', labelKey: `${I18N_PREFIX}.brand_code` },
  { code: 'brandName', labelKey: `${I18N_PREFIX}.brand_name` },
  { code: 'materialId', labelKey: `${I18N_PREFIX}.material_id` },
  { code: 'materialCode', labelKey: `${I18N_PREFIX}.material_code` },
  { code: 'materialName', labelKey: `${I18N_PREFIX}.material_name` },
  { code: 'materialMainImages', labelKey: `${I18N_PREFIX}.material_main_images` },
  { code: 'imageList', labelKey: `${I18N_PREFIX}.image_list` },
  { code: 'showFlag', labelKey: `${I18N_PREFIX}.show_flag` },
  { code: 'status', labelKey: `${I18N_PREFIX}.status`, required: true },
  { code: 'type', labelKey: `${I18N_PREFIX}.type`, required: true },
  { code: 'goodsRemark', labelKey: `${I18N_PREFIX}.goods_remark` },
  { code: 'remark', labelKey: `${I18N_PREFIX}.remark` },
  { code: 'costPrice', labelKey: `${I18N_PREFIX}.cost_price` },
  { code: 'salesPrice', labelKey: `${I18N_PREFIX}.sales_price`, required: true },
  { code: 'activityPrice', labelKey: `${I18N_PREFIX}.activity_price` },
  { code: 'marketPrice', labelKey: `${I18N_PREFIX}.market_price` },
  { code: 'distributionPrice', labelKey: `${I18N_PREFIX}.distribution_price` },
  { code: 'wholesalePrice', labelKey: `${I18N_PREFIX}.wholesale_price` },
  { code: 'clearingPrice', labelKey: `${I18N_PREFIX}.clearing_price` },
  { code: 'weight', labelKey: `${I18N_PREFIX}.weight` },
  { code: 'length', labelKey: `${I18N_PREFIX}.length` },
  { code: 'width', labelKey: `${I18N_PREFIX}.width` },
  { code: 'height', labelKey: `${I18N_PREFIX}.height` },
  { code: 'barcodes', labelKey: `${I18N_PREFIX}.barcodes` },
  { code: 'skuAttributeList', labelKey: `${I18N_PREFIX}.sku_attribute_list` },
  { code: 'otherAttributeList', labelKey: `${I18N_PREFIX}.other_attribute_list` },
];

export const DEFAULT_REQUIRED_SKU_FIELD_CODES = DEFAULT_SKU_PRODUCT_FIELDS.filter((f) => f.required).map((f) => f.code);
